module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["GTM-PPS2SH"],"gtagConfig":{}},
    },{
      plugin: require('../node_modules/gatsby-plugin-adobe-launch/gatsby-browser.js'),
      options: {"plugins":[],"scriptURL":"//assets.adobedtm.com/83c7b58f0b29/66882c504e10/launch-433232d3a1ab-development.min.js","includeInDevelopment":true,"defaultDataLayer":{"platform":"gatsby"},"dataLayerName":"OUEnrolment","routeChangeEventName":"gatsbyRouteChange"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
